import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useRef, useState } from "react";
import { createCarPricesUrl, xxxx_getMakesModels } from "../../helpers/carsPricesHelpers";
import useHelpers from "@hooks/useHelpers";
import SelectTwo from "@componentsShared/SelectTwo/SelectTwo";
import stl from "./CarPriceSearchSection.module.css";
import { useTranslation } from "@i18n";
import { useLang } from "@/common/Contexts/LanguageContext";
import { ucWords } from "@/utils/stringHelpers";
import { useFullPageData } from "@/common/Contexts/FullPageContext";
var CarPriceSearchSection = function CarPriceSearchSection(props) {
  var lang = useLang();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    navigateToHard = _useHelpers.navigateToHard;
  var title = props.title,
    heading = props.heading,
    subtitle = props.subtitle,
    selectedMake = props.selectedMake,
    selectedModel = props.selectedModel,
    year = props.year;
  var carsPricesResponse = useFullPageData();
  var years_list_data = carsPricesResponse.years_list_data;
  var modelSelectRef = useRef(null);
  var yearSelectRef = useRef(null);
  var _xxxx_getMakesModels = xxxx_getMakesModels(carsPricesResponse, lang, null),
    makes = _xxxx_getMakesModels.makes,
    years = _xxxx_getMakesModels.years;
  var _useState = useState(xxxx_getMakesModels(carsPricesResponse, lang, selectedMake).models),
    models = _useState[0],
    setModels = _useState[1];
  var _useState2 = useState({
      make: selectedMake,
      model: selectedModel,
      year: year
    }),
    searchData = _useState2[0],
    setSearchData = _useState2[1];
  var resetDropdown = function resetDropdown() {
    var _modelSelectRef$curre, _yearSelectRef$curren;
    (_modelSelectRef$curre = modelSelectRef.current) === null || _modelSelectRef$curre === void 0 ? void 0 : _modelSelectRef$curre.reset();
    (_yearSelectRef$curren = yearSelectRef.current) === null || _yearSelectRef$curren === void 0 ? void 0 : _yearSelectRef$curren.reset();
  };
  var handleMakeChange = function handleMakeChange(selectedOption) {
    if (selectedOption) {
      setSearchData(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          make: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.item,
          model: null,
          year: null
        });
      });
      setModels(xxxx_getMakesModels(carsPricesResponse, lang, selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.item).models);
    } else {
      setSearchData({
        make: null,
        model: null,
        year: null
      });
    }
  };
  var handleModelChange = function handleModelChange(selectedOption) {
    if (selectedOption) {
      setSearchData(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          model: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.item,
          year: null
        });
      });
    } else {
      setSearchData(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          model: null,
          year: null
        });
      });
    }
  };
  var handleYearChange = function handleYearChange(selectedOption) {
    if (selectedOption) {
      setSearchData(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          year: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.item
        });
      });
    } else {
      setSearchData(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          year: null
        });
      });
    }
  };
  var handleSubmit = function handleSubmit() {
    navigateToHard(createCarPricesUrl(searchData.make, searchData.model, searchData.year));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.container
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(props.heading, null, title), /*#__PURE__*/React.createElement("p", null, subtitle), /*#__PURE__*/React.createElement("div", {
    className: "max-width"
  }, /*#__PURE__*/React.createElement(SelectTwo, {
    className: stl.inputField,
    options: makes.map(function (make) {
      return {
        id: make.id,
        label: ucWords(make.name),
        image: make.logo,
        item: make
      };
    }),
    selectedOption: searchData.make && {
      id: searchData.make.id,
      label: searchData.make.name,
      image: searchData.make.logo,
      item: searchData.make
    },
    onChange: function onChange(option) {
      handleMakeChange(option);
      resetDropdown();
    },
    placeHolder: t("select_car_make", {
      ns: "web_common"
    }),
    topHolder: t("car_make", {
      ns: "web_common"
    })
  }), /*#__PURE__*/React.createElement(SelectTwo, {
    ref: modelSelectRef,
    disabled: !searchData.make,
    className: stl.inputField,
    options: (models !== null && models !== void 0 ? models : []).map(function (model) {
      return {
        id: model.id,
        label: ucWords(model.name),
        item: model
      };
    }),
    selectedOption: searchData.model && {
      id: searchData.model.id,
      label: ucWords(searchData.model.name),
      item: searchData.model
    },
    onChange: handleModelChange,
    placeHolder: t("select_model", {
      ns: "web_common"
    }),
    topHolder: t("model", {
      ns: "web_common"
    })
  }), /*#__PURE__*/React.createElement(SelectTwo, {
    ref: yearSelectRef,
    disabled: !searchData.model,
    className: stl.inputField,
    options: (years !== null && years !== void 0 ? years : []).filter(function (year) {
      return !searchData.model || years_list_data[searchData.make.seo_url + '/' + searchData.model.seo_name + '/' + year];
    }).map(function (year) {
      return {
        id: year + "",
        label: year + "",
        item: year
      };
    }),
    selectedOption: searchData.year && {
      id: searchData.year + "",
      label: searchData.year + "",
      item: searchData.year
    },
    onChange: handleYearChange,
    placeHolder: t("select_year_manufacture", {
      ns: "web_common"
    }),
    topHolder: t("year_manufacture", {
      ns: "web_common"
    })
  }), /*#__PURE__*/React.createElement("button", {
    onClick: handleSubmit,
    className: [stl.searchBtn, "redBtn", !searchData.make ? stl.searchBtnDisabled : undefined].join(" ")
  }, t("search", {
    ns: "web_common"
  }))))));
};
export default CarPriceSearchSection;